import { rem } from '../tokens/spacing';
import type { Density } from './types';

export function getDensityTokens(density: Density): Record<string, string> {
  if (density === 'compact') {
    return {
      '--ui-space-xs': rem(2),
      '--ui-space-sm': rem(6),
      '--ui-space-md': rem(12),
      '--ui-space-lg': rem(18),
      '--ui-space-xl': rem(24),
      '--ui-space-xxl': rem(32),
      '--ui-control-height-sm': rem(28),
      '--ui-control-height-md': rem(36),
      '--ui-control-height-lg': rem(44),
    };
  }

  return {
    '--ui-space-xs': rem(4),
    '--ui-space-sm': rem(8),
    '--ui-space-md': rem(16),
    '--ui-space-lg': rem(24),
    '--ui-space-xl': rem(32),
    '--ui-space-xxl': rem(48),
    '--ui-control-height-sm': rem(32),
    '--ui-control-height-md': rem(40),
    '--ui-control-height-lg': rem(48),
  };
}
